import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, WritableSignal, signal, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PageComponent } from 'src/app/layout/pages/page/page.component';
import { EditableCardComponent } from 'src/app/shared/components/cards/editable-card/editable-card.component';
import { TextFieldComponent } from 'src/app/shared/components/fields/text-field/text-field.component';
import { ParametriService } from '../parametri.service';
import { RangeFieldComponent } from 'src/app/shared/components/fields/range-field/range-field.component';
import { IParametro } from '../parametri.model';
import { PageDetailComponent } from 'src/app/layout/pages/page-detail/page-detail.component';
import { BooleanFieldComponent } from 'src/app/shared/components/fields/boolean-field/boolean-field.component';
import { NewFormComponent } from '../components/new-form/new-form.component';

@Component({
  selector: 'app-parametri-dettaglio-page',
  standalone: true,
  imports: [
    CommonModule,
    PageDetailComponent,
    EditableCardComponent,
    TextFieldComponent,
    RangeFieldComponent,
    BooleanFieldComponent,
    NewFormComponent
  ],
  templateUrl: './dettaglio-page.component.html',
  styleUrl: './dettaglio-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DettaglioPageComponent implements OnInit {
  @Input() id = '0';

  form: FormGroup;
  model: WritableSignal<IParametro | undefined> = signal(undefined);
  reload: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private readonly fb: FormBuilder,
    public readonly service: ParametriService
  ) {
    this.form = this.fb.group({})
  }

  ngOnInit(): void {
  }
  // ngOnInit() {
  //   if (this.id) {
  //     this.service.read(this.id).subscribe((value: any) => {
  //     this.data.set(value);
  //     })
  //   }
  // }
}
